import * as React from 'react'

function IconEmail(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={41}
      height={33}
      viewBox="0 0 41 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32.367 30.642H8.633c-3.495 0-6.327-2.895-6.327-6.468V8.826c0-3.573 2.832-6.468 6.327-6.468h23.734c3.495 0 6.327 2.895 6.327 6.468v15.348c0 3.573-2.832 6.468-6.327 6.468z"
        stroke="#C4C4C4"
        strokeWidth={5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M9.204 10.556l7.952 10.342c1.696 2.202 3.974 2.322 5.737.301l9.275-10.64"
        stroke="#C4C4C4"
        strokeWidth={5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconEmail
